export default {
  'processPortal.title': 'Manage Process Portal',

  'processPortal.form.id': 'ID',
  'processPortal.form.enable': 'Enable',
  'processPortal.form.name': 'Name',
  'processPortal.form.description': 'Description',
  'processPortal.form.shortenedUrl': 'Shortened Url',
  'processPortal.form.openUrl': 'Open Url',

  'processPortal.form.statusLabel': 'Is Enabled?',
  'processPortal.form.detailStatus': 'Enabled?',

  'processPortal.enabled': 'Enabled',
  'processPortal.disabled': 'Disabled',

  'processPortal.tblOrder': 'Order',
  'processPortal.tblProcess': 'Process Name',
  'processPortal.form.order': 'Process Order',
  'processPortal.form.selectProcess': 'Select a Process',
  'processPortal.form.exist': 'Process already exists',
  'processPortal.config.publicUrl': 'Public Url',
  'processPortal.config.disabled': 'Url disabled',
  'processPortal.config.activate': 'Activate Url',
  'processPortal.config.desactivate': 'Deactivate Url',
  'processPortal.config.open': 'Open Url',
  'processPortal.form.shortCode': 'ShortCode',
  'processPortal.searchConfig': 'Search',
  'processPortal.titleProcess': 'Configure Processes',
  'processPortal.descriptionProcess': 'Configure the processes that will appear in the portal',
  'processPortal.titleReport': 'Configure Reports',
  'processPortal.descriptionReport': 'Configure the reports that will appear in the portal',
  'processPortal.titlePermission': 'Configure Permissions',
  'processPortal.descriptionPermission': 'Configure access permissions to the portal',
  'processPortal.titleList': 'Configure Lists',
  'processPortal.descriptionList': 'Configure the lists that will appear in the portal',
  'processPortal.titleEntity': 'Configure Entities',
  'processPortal.descriptionEntity': 'Configure the entities that will appear in the portal',
  'processPortal.titleMenu': 'Configure Menu',
  'processPortal.descriptionMenu': 'Configure the menu structure for the process portal',

  'processPortal.selected.config-process': 'Processes',
  'processPortal.selected.config-report': 'Reports',
  'processPortal.selected.config-permission': 'Permissions',
  'processPortal.selected.config-list': 'Lists',
  'processPortal.selected.config-entity': 'Entities',
  'processPortal.selected.config-menu': 'Menu',

  'processPortal.title.config-process': 'Configure Processes',
  'processPortal.title.config-report': 'Configure Reports',
  'processPortal.title.config-permission': 'Configure Permissions',
  'processPortal.title.config-list': 'Configure Lists',
  'processPortal.title.config-entity': 'Configure Entities',
  'processPortal.title.config-menu': 'Configure Menu',

  'processPortal.options.template.basic': 'Basic',

  'processPortal.form.mainColor': 'Main Color',
  'processPortal.form.logoUrl': 'Logo (Url)',
  'processPortal.form.template': 'Template',
  'processPortal.form.loginSplashUrl': 'Login Splash (Url)',
  'processPortal.form.fontUrl': 'Font (Url)',
  'processPortal.form.iconLogoUrl': 'Icon (Url)',
  'processPortal.form.faviconUrl': 'Favicon (Url)',
  'processPortal.form.permissionsFiltersLogicalOperator': 'Permissions Filters Logical Operator',

  'processPortal.menu.customList': 'List',
  'processPortal.menu.customLists': 'All Lists',
  'processPortal.menu.dynamicEntity': 'Dynamic Entity',
  'processPortal.menu.dynamicEntities': 'All Dynamic Entities',
  'processPortal.menu.report': 'Report',
  'processPortal.menu.reports': 'All Reports',
  'processPortal.menu.process': 'Process',
  'processPortal.menu.processes': 'All Processes',
  'processPortal.menu.link': 'Link',
  'processPortal.menu.subMenu': 'Dropdown Menu',
  'processPortal.menu.embedHtml': 'Embedded HTML',
  'processPortal.menu.parentSubMenu': 'Parent Sub Menu',
  'processPortal.menu.type': 'Type',
  'processPortal.menu.htmlFile': 'HTML File',
  'processPortal.menu.preview': 'Preview',

  'processPortal.action.generatePublicUrl': 'Generate Public URL',
  'processPortal.action.deactivatePublicUrl': 'Deactivate Public URL',
};
